"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseNumberFromString = void 0;
/**
 * Removes all delimiters from the currency string and parses it to a number.
 *
 * @param value
 */ var parseNumberFromString = function(value) {
    return Number.parseFloat(value.replaceAll(/\D/g, ''));
};
exports.parseNumberFromString = parseNumberFromString; //# sourceMappingURL=parseNumberFromString.js.map
